export const StandardPurpose: string = `Thank you for participating in our AI interview experience...
When you begin, you will be interviewed to learn more about your career experience and what you are looking for in a future role.
There will be approximately 10 questions.
Please answer the questions as you would want them viewed by a potential employer (ex: using complete sentences and watching for typos/errors the best you can).`;
